module.exports = __webpack_public_path__ + "static/img/AO.0752d590.svg";